import { isBrowser } from '@lib/environment/isBrowser';

export function isDatadogSynthetics(): boolean {
  return isBrowser() && window.navigator.userAgent.includes('DatadogSynthetics');
}
